import * as api from '@pointOfSale/api';
import { SaleRate } from '../models';
import * as MutationTypes from '../mutationTypes';

export const saleRateListRequest = async ({ commit, getters: { saleRateList } }, pointOfSaleGuid) => {
  if (saleRateList.length === 0) {
    const response = await api.saleRateListRequest(pointOfSaleGuid);
    const saleRateListRes = SaleRate.toInstanceList(response.data);
    commit(MutationTypes.SALE_RATE_LIST_SUCCESS, saleRateListRes);
  }
  return saleRateList;
};
